import { initializeApp } from 'firebase/app';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyAtErVfQDZ_eO1E0pTM5SFIPWbRwCW1TY0',
  authDomain: 'serene-office.firebaseapp.com',
  projectId: 'serene-office',
  storageBucket: 'serene-office.firebasestorage.app',
  messagingSenderId: '638084233467',
  appId: '1:638084233467:web:25a45035303b606e2e985e',
};

const firebaseApp = initializeApp(firebaseConfig);
const firebaseFunctions = getFunctions(firebaseApp, 'europe-west1');

export { firebaseApp, firebaseFunctions };
export default firebaseApp;
